var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-default',[_c('em',[_vm._v("We are suspending our texting service starting the 5th of July.")]),_c('CStickyBtnGroup',{attrs:{"position":"top"}},[_c('CNewConverstionButton')],1),_c('CConversationsList'),_c('CAdOmnexio')],1)}
var staticRenderFns = []

export { render, staticRenderFns }